import imageTransformator from "./imageTransformator";

// Transforms a single image
// If image === false -> it should be deleted
// If image === null -> it should not be changed
// If image is something else -> it should be updated
const imageArrayTransformator = {
  toModelAttribute(value) {
    const image = imageTransformator.toModelAttribute(value);
    return image === false ? [] : image === null ? null : [image];
  },

  // TODO more docs, because this is complicated
  toFormAttribute(value) {
    const image = Array.isArray(value)
      ? null
      : imageTransformator.toFormAttribute(value);
    return image === false ? [] : image === null ? null : [image];
  },
};

export default imageArrayTransformator;
